import React from 'react';

const e = React.createElement;

// @TODO_WHN styling/content

function PageNotFound() {}
PageNotFound.prototype = Object.create(React.Component.prototype);

PageNotFound.prototype.render = function() {
  return e('div', {style:{"padding":"14px"}}, [
    e('h1', {key:"1"}, "404 Page not found"),
    e('p', {key:"2"}, this.props.location.pathname),
    e('a', {key:"3", href:"/"}, "return to the homepage"),
  ]);
}


export default PageNotFound



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/PageNotFound.js
// module id = 184
// module chunks = 0